var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-text-field',{attrs:{"label":_vm.labelText,"value":_vm.value,"hide-details":"auto","readonly":"","outlined":"","disabled":"","suffix":_vm.suffix}})}
var staticRenderFns = []

export { render, staticRenderFns }